import {
  ArrowLeftOutlined,
  CheckCircleFilled,
  PhoneFilled,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Space,
  theme,
  Typography,
  Radio,
  InputNumber,
  Card,
} from "antd";
import React, { useState, useEffect, useCallback } from "react";
import Heading from "../../../components/common/heading";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import WithSidebar from "../../../templates/withSidebar";
import { useNavigate, useLocation } from "react-router-dom";
import { routes } from "../../../routes";
import Validation, { getUnique, channelList } from "./components/dataReport";
import {
  getDetailTouchPointPage,
  getChanel,
} from "../../../services/customerTouchPoint";
import useTouchpoint from "../../../lib/hooks/useTouchpoint";

const { useToken } = theme;

const { Title } = Typography;
const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text, Link } = Typography;
const { Option } = Select;
const { TextArea } = Input;



export const ViewTouchPoint = () => {
  const navigate = useNavigate();
  const { setQuestionValues, setHeaderValues } = useTouchpoint();
  const location = useLocation();
  const { token } = useToken();
  const [form] = Form.useForm();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const [optionsYear, setOptionYear] = useState([]);
  const [qaList, setQaList] = useState([]);
  const [agencyType, setAgencyType] = useState("");
  const [agencyChannel, setAgencyChannel] = useState("");
  const [dataDetail, setDataDetail] = useState([]);

  const [vocData, setVocData] = useState({});

  console.log("dataDetail", dataDetail);
  const [viewID, setViewID] = useState(
    location.state.id ? location.state.id : ""
  );
  const [actionType, setActionType] = useState(
    location.state.action_type ? location.state.action_type : ""
  );

  const onChangePage = () => {
    setOpenCancelModal(true);
  };

  const onFinish = (values) => {
    // console.log("values : ", values);
  };

  const getChanelData = async (value) => {
    const res = await getChanel(value);

    if (res.data.code === "0000") {
      setQaList(res.data.objectValue);
    }
  };

  const getDetail = useCallback(async () => {
   console.log("getDetailTouchPointPage===>");
    const res = await getDetailTouchPointPage(viewID.touchPointAnswerId);
    const vocMap = {};
    if (res.data.code === "0000") {

      console.log("View Page getDetailTouchPointPage =res.data.objectValue =>");
      console.log(res.data.objectValue);
      setDataDetail(res.data.objectValue);
      getChanelData(res.data.objectValue.institutionId);
      console.log("STEP 01'");
      channelList.map((channelName) => {
        const resultX = res.data.objectValue.answerDetailResponseList.filter(
          (item) => {
            console.log("STEP 11'");
            return item.channel === channelName;
          }
        );

        console.log("STEP 21'");
        //  const result_voc = res.data.objectValue.vocDetail.filter(
        //   (item) => {
        //     return item.channel === channelName;
        //   }
        // );
       console.log("STEP 22'");

        if (resultX.length > 0) {
          console.log("STEP 23'");
          vocMap[channelName] = resultX[0].vocDetail;
          console.log("SET VOC TO MAP==>");
          console.log(resultX[0].vocDetail);
          localStorage.setItem(
            channelName,
            JSON.stringify({
              agencyType: res.data.objectValue.institutionId,
              agencyChannel: channelName,
              questionDetail: resultX,
              vocDetail: resultX[0].vocDetail
            })
          );
        }
        
      });
      setVocData(vocMap);

      console.log("vocData===>");
      console.log(vocData);
    }
  }, [dataDetail]);

  useEffect(() => {
    getDetail();
  }, [location]);

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.customer_tab_touchpoint);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"รายละเอียด"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "คลังข้อมูล Touch point ",
                },
                {
                  title: <span className="pr_green">รายละเอียด</span>,
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[8, 16]} className="card">
                <Col span={24}>
                  <Heading
                    text={"ข้อมูลแบบสอบถาม"}
                    size={4}
                    style={{ margin: 0, color: token.thPrimary }}
                  />
                  <Divider />
                </Col>

                <Col span={16}>
                  <Row gutter={[8, 16]}>
                    <Col span={12}>
                      <Form.Item
                        label={<Text className="pr_green">ไตรมาศ</Text>}
                        name={"t1"}
                      >
                        <Text>
                          {dataDetail.quarterOfBudget +
                            "/" +
                            dataDetail.yearOfBudget}
                        </Text>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label={<Text className="pr_green">หน่วยงาน</Text>}
                        name={"agency"}
                      >
                        <Text>{dataDetail.institutionName}</Text>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                {agencyType === "สำนักงานนิคมอุตสหกรรม" && (
                  <>
                    <Col span={16}>
                      <Row gutter={[8, 16]}>
                        <Col span={12}>
                          <Form.Item
                            label={
                              <Text className="pr_green">
                                ชื่อนิคมอุตสาหกรรม
                              </Text>
                            }
                            name={"industrial_name"}
                          >
                            <Text>
                              {dataDetail.estateName
                                ? dataDetail.estateName
                                : "-"}
                            </Text>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={[8, 16]}>
                        <Col span={12}>
                          <Form.Item
                            label={<Text className="pr_green">สายงาน</Text>}
                            name={"line_of_work"}
                          >
                            <Text>
                              {dataDetail.lineOfWorkName
                                ? dataDetail.lineOfWorkName
                                : "-"}
                            </Text>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </>
                )}

                <>
                  <Divider />
                  <Card style={{ width: "80%" }}>
                    <Heading
                      text={"เลือก Touch Point เพื่อทำแบบสอบถาม"}
                      size={4}
                      style={{ margin: "0px 0px 10px 0px" }}
                    />
                    {qaList.map((item, index) => {
                      let chkFlag = JSON.parse(
                        localStorage.getItem(item.channel)
                      );
                      return (
                        <>
                          {chkFlag != null ? (
                            <>
                              <Row
                                key={item.institutionId}
                                style={{ paddingBottom: 10 }}
                              >
                                <Col span={18}>
                                  <Link
                                    key={item.institutionId + index}
                                    onClick={() => {
                                      navigate(
                                        routes.view_customer_touchpoint_page,
                                        {
                                          state: {
                                            agency_type: item.institutionId,
                                            agency_name: item.header,
                                            agency_detail: JSON.parse(
                                              localStorage.getItem(item.channel)
                                            ),
                                            agency_channel: item.channel,
                                            action_type: actionType,
                                            agency_header: item.headerDetail,
                                            status_data: "avilable_data",
                                            voc_detail: vocData[item.channel],
                                            // agency_type: item.institutionId,
                                            // agency_name: item.header,
                                            // agency_detail: JSON.parse(localStorage.getItem(item.channel)),
                                            // agency_channel: item.channel,
                                            // agency_header: item.headerDetail,
                                            // action_type: actionType,
                                            // header: [
                                            //     {
                                            //         agency: agencyType,
                                            //         quarter: quarterValue,
                                            //         line_of_work: "",
                                            //         industrial_name: "",
                                            //         name_reporter: nameReporter,
                                            //         position_reporter: positionReporter,
                                            //         tel_reporter: telReporter,
                                            //     },
                                            // ],
                                          },
                                        }
                                      );
                                    }}
                                    underline
                                  >
                                    {item.header}
                                  </Link>
                                </Col>
                                <Col span={6}>
                                  <CheckCircleFilled
                                    style={{
                                      paddingRight: 5,
                                      color: "#4ACE8F",
                                    }}
                                  />
                                  ทำแบบสอบถามเรียบร้อยแล้ว
                                </Col>
                              </Row>
                            </>
                          ) : (
                            <>
                              <Row
                                key={item.institutionId}
                                style={{ paddingBottom: 10 }}
                              >
                                <Col span={18}>
                                  <Text
                                    key={item.institutionId + index}
                                    disabled
                                  >
                                    {item.header}
                                  </Text>
                                </Col>
                                <Col span={6}>
                                  <CheckCircleFilled
                                    style={{ paddingRight: 5, color: "gray" }}
                                  />
                                  ยังไม่ได้ทำแบบสอบถาม
                                </Col>
                              </Row>
                            </>
                          )}
                        </>
                      );
                    })}
                  </Card>

                  <Col span={24}>
                    <Heading
                      text={"ข้อมูลแบบสอบถาม"}
                      size={4}
                      style={{ margin: 0, color: token.thPrimary }}
                    />
                  </Col>
                  <Col span={16}>
                    <Form.Item
                      label={
                        <Text className="pr_green">ชื่อ-นามสกุลผู้รายงาน</Text>
                      }
                      name={"name"}
                    >
                      <Text>{dataDetail.name}</Text>
                    </Form.Item>
                  </Col>
                  <Col span={16}>
                    <Row gutter={[8, 16]}>
                      <Col span={12}>
                        <Form.Item
                          label={
                            <Text className="pr_green">
                              ตำแหน่งผู้รับรายงาน
                            </Text>
                          }
                          name={"position_report"}
                        >
                          <Text>{dataDetail.positionName}</Text>
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label={
                            <Text className="pr_green">
                              เบอร์ติดต่อผู้รายงาน
                            </Text>
                          }
                          name={"tel_reporter"}
                        >
                          <Text>{dataDetail.phone}</Text>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={16}>
                    <Form.Item
                      label={<Text className="pr_green">ชื่อโรงงาน</Text>}
                      name={"factoryName"}
                    >
                      <Text>{dataDetail.factoryName}</Text>
                    </Form.Item>
                  </Col>
                </>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>
    </WithSidebar>
  );
};
